/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React from "react";
import Header from "./Header";
import Table from "./Table";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default function Tags(): JSX.Element | null {
  return (
    <Container>
      <Header />

      <Table />
    </Container>
  );
}
